import {SOPostDeficiency} from '../../core/deficiency/so-post-deficiency';
import {DeficiencyCore} from './deficiency.core';
import {SOGetDeficiency} from '../../core/deficiency/so-get-deficiency';
import {FormField, SelectionOption} from 'lionheartland';
import {postDeficiencyFormFieldOptions} from './post-deficiency-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {AssessmentCore} from '../assessment/assessment.core';
import {SOGetAssessment} from '../../core/assessment/so-get-assessment';
import {BlockCore} from '../block/block.core';
import {SOGetBlock} from '../../core/block/so-get-block';
import {ProcessCore} from '../process/process.core';
import {SOGetProcess} from '../../core/process/so-get-process';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostDeficiency extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postDeficiencyFormFieldOptions);

  RequestClass = SOPostDeficiency

  constructor(
    public entityCore: DeficiencyCore
  ) {
    super();
    if (postDeficiencyFormFieldOptions.assessment) {
      postDeficiencyFormFieldOptions.assessment.makeCore = true;
    }
    if (postDeficiencyFormFieldOptions.block) {
      postDeficiencyFormFieldOptions.block.makeCore = true;
    }
    if (postDeficiencyFormFieldOptions.process) {
      postDeficiencyFormFieldOptions.process.makeCore = true;
    }
    if (postDeficiencyFormFieldOptions.project) {
      postDeficiencyFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier('severity'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'assessment',
        SOGetAssessment,
      ),
      this.getFormValueFromIdentifier(
        'block',
        SOGetBlock,
      ),
      this.getFormValueFromIdentifier(
        'process',
        SOGetProcess,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}